import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading, HeadingType, Box } from '@as/cotopaxi';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { ProductTopFiveTile } from './ProductTopFiveTile';
import { Divider } from '@yonderland/andes-react';
const ProductTopFive = ({ title, products }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    if (!(products === null || products === void 0 ? void 0 : products.length))
        return null;
    return (_jsxs(Box, { children: [_jsx(Heading, { type: HeadingType.TITLE, children: title || t('product.top.default') }), products.map((product, index) => (_jsxs(Fragment, { children: [_jsx(Box, { mobile: { spacing: { marginTop: 2, marginBottom: 2 } }, children: _jsx(ProductTopFiveTile, { product: product, ranking: index + 1 }) }), _jsx(Divider, {})] }, `${product.productId}_${product.colourId}`)))] }));
};
export default ProductTopFive;
